import {
    putRouteStatusFakeShippingLoading,
    putRouteStatusFakeShippingRequest,
    putRouteStatusFakeShippingSuccess,
    putRouteStatusFakeShippingReject,
    putRouteStatusFakeShippingReset
} from "../../actions/route/putStatusFakeShippingRoute";

export const putRouteStatusFakeShipping = (formData) => async (dispatch, getState) => {
    dispatch(putRouteStatusFakeShippingLoading());
    try {
        const { data } = await putRouteStatusFakeShippingRequest(formData, getState);
        dispatch(putRouteStatusFakeShippingSuccess(data))
    } catch (error) {
        dispatch(putRouteStatusFakeShippingReject(error))
    } finally {
        setTimeout(() => { dispatch(putRouteStatusFakeShippingReset()) }, 3000);
    }
    return Promise.resolve();
};